import { IMessageBarProps } from "@fluentui/react";
import { memo } from "react";
import { useAppContext } from "../Contexts";
import { BaseErrorMessageBar } from "./BaseErrorMessageBar";

/**
 * Renders an error message bar using either the provided error prop or the error from context.
 * If no error is provided, renders nothing.
 */
export const ErrorMessageBar = memo(
  (props: { error?: any } & Omit<IMessageBarProps, "messageBarType">) => {
    const { error, ...restProps } = props;
    const { error: errorContext } = useAppContext();
    const errorToUse = error || errorContext;

    return <BaseErrorMessageBar error={errorToUse} {...restProps} />;
  },
);
